/**
 * Defines an output path from a state.
 */
export class Output {
}
export var OutputTypeStateId;
(function (OutputTypeStateId) {
    OutputTypeStateId["State"] = "state";
    OutputTypeStateId["Variable"] = "variable";
})(OutputTypeStateId || (OutputTypeStateId = {}));
